import React, { useEffect, useState } from "react";
import { api, resolveUrl, formatApiError } from "../../lib/api";
import { Star, Check, X, Trash2 } from "lucide-react";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("");

  const load = async () => {
    const r = await api.get("/admin/reviews", { params: filter ? { status: filter } : {} });
    setReviews(r.data);
  };
  useEffect(() => { load(); }, [filter]);

  const approve = async (id) => { await api.post(`/admin/reviews/${id}/approve`); await load(); };
  const reject = async (id) => { await api.post(`/admin/reviews/${id}/reject`); await load(); };
  const remove = async (id) => { if (!window.confirm("Stergi recenzia?")) return; await api.delete(`/admin/reviews/${id}`); await load(); };

  return (
    <div data-testid="admin-reviews">
      <div className="flex items-center justify-between mb-10">
        <div>
          <div className="label-eyebrow mb-2" style={{ color: "var(--brand-primary)" }}>Panou admin</div>
          <h1 className="font-serif text-3xl sm:text-4xl">Recenzii</h1>
        </div>
        <select className="brand-input w-auto" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="review-filter">
          <option value="">Toate</option>
          <option value="pending">In asteptare</option>
          <option value="approved">Aprobate</option>
          <option value="rejected">Respinse</option>
        </select>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {reviews.map((r) => (
          <div key={r.id} className="card-surface p-6" data-testid={`review-${r.id}`}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="label-eyebrow mb-1">{r.car_name}</div>
                <h3 className="font-serif text-lg">{r.guest_name}</h3>
                <div className="flex gap-0.5 mt-1">
                  {[1,2,3,4,5].map((n) => (
                    <Star key={n} className="w-3.5 h-3.5" fill={n <= r.rating ? "var(--brand-primary)" : "none"} stroke="var(--brand-primary)" />
                  ))}
                </div>
              </div>
              <span className="label-eyebrow" style={{ color: r.status === "approved" ? "var(--brand-primary)" : r.status === "rejected" ? "#ef4444" : "var(--brand-text-secondary)" }}>{r.status}</span>
            </div>
            {r.comment && <p className="text-sm mb-3" style={{ color: "var(--brand-text-secondary)" }}>"{r.comment}"</p>}
            {r.media?.length > 0 && (
              <div className="grid grid-cols-3 gap-2 mb-3">
                {r.media.map((m) => (
                  <div key={m.id} className="aspect-square overflow-hidden border" style={{ borderColor: "var(--brand-border)" }}>
                    {m.type === "image" ? (
                      <img src={resolveUrl(m.url)} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <video src={resolveUrl(m.url)} className="w-full h-full object-cover" controls />
                    )}
                  </div>
                ))}
              </div>
            )}
            <div className="flex gap-2 pt-3 border-t" style={{ borderColor: "var(--brand-border)" }}>
              {r.status !== "approved" && <button onClick={() => approve(r.id)} className="btn-ghost flex items-center gap-1.5" data-testid={`approve-review-${r.id}`}><Check className="w-3.5 h-3.5" /> Aproba</button>}
              {r.status !== "rejected" && <button onClick={() => reject(r.id)} className="btn-ghost flex items-center gap-1.5" data-testid={`reject-review-${r.id}`}><X className="w-3.5 h-3.5" /> Respinge</button>}
              <button onClick={() => remove(r.id)} className="btn-ghost ml-auto" data-testid={`delete-review-${r.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <div className="md:col-span-2 text-center py-16 text-sm" style={{ color: "var(--brand-text-secondary)" }}>Nicio recenzie</div>}
      </div>
    </div>
  );
}
